const initWebJS = () => {};

document.addEventListener("DOMContentLoaded", initWebJS);
